var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row align-items-center no-gutters" }, [
      _c("div", { staticClass: "col-4 col-md-3" }, [
        _vm.payment.brand === "visa"
          ? _c("img", {
              attrs: {
                src: "/static/img/brand-visa.svg",
                height: "60",
                alt: "visa"
              }
            })
          : _vm.payment.brand === "mastercard"
          ? _c("img", {
              attrs: {
                src: "/static/img/brand-master-card.svg",
                height: "60",
                alt: "master card"
              }
            })
          : _c("img", {
              attrs: {
                src: "/static/img/brand-jcb.svg",
                height: "60",
                alt: "jcb"
              }
            })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-8 col-md-9" }, [
        _vm._v("\n      ●●●● " + _vm._s(_vm.payment.last_digits)),
        _c("br"),
        _vm._v(
          "\n        " +
            _vm._s(_vm.payment.expire_month) +
            " / " +
            _vm._s(_vm.payment.expire_year) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _vm.payment.is_expired
      ? _c("div", { staticClass: "text-remark -status-alert" }, [
          _vm._v(
            "(" +
              _vm._s(_vm.$t("message.booking.payment_step.card_is_expired")) +
              ")"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4433718c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4433718c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentSmall.vue
// module id = 1714
// module chunks = 0